/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/Search/Professional/Professionals/No"
  
}) {
  return null
}